import React from "react";

const MintContext = React.createContext(false);

export default MintContext;